import {
    AfterContentInit,
    Component,
    ContentChildren,
    OnDestroy,
    QueryList
} from '@angular/core';
import { Subscription } from 'rxjs';

import { TreeLevelComponent } from '../tree-level/tree-level.component';

@Component({
    selector: 'app-tree',
    templateUrl: './tree.component.html',
    standalone: false
})
export class TreeComponent implements AfterContentInit, OnDestroy {
    @ContentChildren(TreeLevelComponent, { descendants: true }) public levels!: QueryList<TreeLevelComponent>;
    private expandedNodes: string[] = [];
    private subscriptions: Subscription[] = [];

    ngAfterContentInit() {
        this.subscriptions.push(
            this.levels.changes.subscribe(value => {
                this.attachToLevels(value);
            }),
        );

        this.attachToLevels(this.levels);
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) subscription.unsubscribe();
    }

    isExpanded(nodeId: string): boolean {
        return this.expandedNodes.includes(nodeId);
    }

    toggleExpanded(nodeId: string): boolean {
        if (this.isExpanded(nodeId)) {
            this.expandedNodes = this.expandedNodes.filter(id => id !== nodeId);

            return false;
        } else {
            this.expandedNodes.push(nodeId);

            return true;
        }
    }

    private attachToLevels(value: QueryList<TreeLevelComponent>) {
        for (const level of value) level.attachToTreeComponent(this);
    }
}
